"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Facebook, Twitter, Instagram, CircleAlert } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/20 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socialLinks = [{
    name: "Facebook",
    icon: Facebook,
    href: "#"
  }, {
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }, {
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }];
  return <section data-section-id="233158" id="footer" className="bg-background pt-16 pb-8 border-t border-primary/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="inline-block">
              
            </Link>
            <p className="text-muted-foreground font-default leading-relaxed">
              Advocates & Solicitors specializing in Employment Law and Civil Litigation. We listen, analyze and solve with 29 years of legal excellence.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold font-default text-primary mb-6">
              Quick Links
            </h3>
            <MenuProvider menu_id="67">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold font-default text-primary mb-6">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted-foreground font-default">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <span>PG-32, Perdana Shopping Centre, No.15, Jalan PJU 8/1, Damansara Perdana, 47820 Petaling Jaya, Selangor</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-default">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <span>019-3270771</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-default">
                <CircleAlert className="w-5 h-5 text-primary shrink-0" />
                <span className="text-foreground font-medium">WhatsApp: 019-3270771</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-default">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <span>shkazrin@gmail.com</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold font-default text-primary mb-6">
              Follow Our Firm
            </h3>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.name} to={social.href} data-index={i} className="w-10 h-10 rounded-sm bg-secondary border border-primary/20 flex items-center justify-center text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-sm" aria-label={social.name}>
                    <Icon className="w-5 h-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-primary/20" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] text-muted-foreground font-mono uppercase tracking-widest">
          <p>© {new Date().getFullYear()} SHAIK AZRIN & CO. ALL RIGHTS RESERVED.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}